import { UIPanel, UIRow } from '@/components/assets/js/libs/ui.js';

function MenubarRemote( editor ) {

	const strings = editor.strings;

	const container = new UIPanel();
	container.setClass( 'menu' );

	const title = new UIPanel();
	title.setClass( 'title' );
	title.setTextContent( strings.getKey( 'menubar/Remote' ) );
	container.add( title );
	container.dom.style.margin = '10px 0px 10px 0px'; // 상 우 하 좌

	container.dom.style.height = '60px'; // 원하는 높이값으로 조절

	const options = new UIPanel();
	options.setClass( 'options' );
	container.add( options );
	options.dom.style.margin = '18px 0px 10px 0px'; // 상 우 하 좌



	let option = new UIRow();
	option.setClass( 'option' );
	option.setTextContent( strings.getKey( 'menubar/Remote/Remote_support' ) );
	option.onClick( function () {

		window.open( 'https://939.co.kr/stni001/', '_blank' );

	} );
	options.add( option );

	return container;

}

export { MenubarRemote };
